<div class="cookie-consent-container">
  <div class="cookie-consent-content">
    <div class="cookie-consent-icon">
      <mat-icon>info</mat-icon>
    </div>
    <p class="cookie-consent-text">
      This site uses cookies to enhance your experience, analyse site usage, and assist in our marketing efforts.
      By choosing an option, you consent to our use of cookies. You can accept all cookies or only essential
      cookies that are necessary for the site to function properly.
    </p>
  </div>

  <div class="cookie-consent-actions">
    <button mat-flat-button color="primary" (click)="acceptAll()">
      Accept all cookies
    </button>
    <button mat-flat-button color="primary" (click)="acceptEssential()">
      Accept only essential cookies
    </button>
  </div>
</div>